<template>
<div class="group flex flex-col sm:flex-row gap-6 bg-card border border-app rounded-lg lg:rounded-[2rem] p-4 lg:p-6 transition-all duration-300 hover:bg-muted/10 hover:shadow-2xl hover:shadow-emerald-500/5 hover:border-emerald-500/30">
    <div
        class="w-full sm:w-56 h-56 rounded-2xl overflow-hidden shrink-0 relative bg-muted shadow-inner">
        <img v-if="item.imageUrl" :src="item.imageUrl" :alt="item.name"
            class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
        <div v-else
            class="w-full h-full bg-gradient-to-br from-emerald-500/20 to-teal-500/20 flex items-center justify-center transition-transform duration-700 group-hover:scale-105">
            <Target
                class="h-16 w-16 text-emerald-500/40 transform group-hover:scale-110 transition-transform duration-500" />
        </div>
        <div v-if="item.isActive"
            class="absolute top-3 left-3 flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-500 text-white shadow-lg backdrop-blur-md border border-white/20">
            <div class="w-2 h-2 rounded-full bg-white animate-pulse relative">
                <div class="absolute inset-0 bg-white rounded-full animate-ping opacity-75"></div>
            </div>
            <span class="text-[10px] font-bold uppercase tracking-wider">Active</span>
        </div>
    </div>
    <div class="flex-1 flex flex-col justify-center py-2">
        <h4
            class="text-2xl font-bold text-header mb-3 group-hover:text-emerald-500 transition-colors leading-tight">
            {{ item.name }}</h4>
        <p class="text-body/80 text-sm leading-relaxed mb-6 line-clamp-3">{{ item.description }}
        </p>

        <div
            class="mt-auto flex flex-col gap-2.5 p-4 rounded-xl bg-body/50 border border-app/50 group-hover:bg-body transition-colors">
            <div class="flex items-center justify-between text-sm">
                <span class="flex items-center gap-2 font-bold text-body/80">
                    <Calendar class="h-4 w-4 text-emerald-500" /> Starts
                </span>
                <span class="font-bold text-header">{{ item.startDate ? ($filter && $filter.day ?
                    $filter.day(item.startDate) : getMonth(item.startDate) + ' ' +
                    getDayNum(item.startDate)) : 'TBD' }}</span>
            </div>
            <div class="w-full h-px bg-gradient-to-r from-transparent via-app to-transparent"></div>
            <div class="flex items-center justify-between text-sm">
                <span class="flex items-center gap-2 font-bold text-body/80">
                    <Clock class="h-4 w-4 text-emerald-500 opacity-60" /> Ends
                </span>
                <span class="font-bold text-header">{{ item.endDate ? ($filter && $filter.day ?
                    $filter.day(item.endDate) : getMonth(item.endDate) + ' ' +
                    getDayNum(item.endDate)) : 'Ongoing' }}</span>
            </div>
        </div>
    </div>
</div>
</template>

<script lang="ts" setup>
import {
    Megaphone,
    Calendar,
    Target,
    LayoutGrid,
    MapPin,
    ArrowRight,
    Clock,
} from 'lucide-vue-next';

const props = defineProps<{
    item: Record<string, any>;
}>();

// Helper functions for dates since $filter.day might just return ISO or localized simple string.
const getMonth = (isoDate: string) => {
    if (!isoDate) return '';
    try {
        const d = new Date(isoDate);
        if (isNaN(d.getTime())) return '';
        return d.toLocaleString('default', { month: 'short' });
    } catch (e) { return ''; }
}
const getDayNum = (isoDate: string) => {
    if (!isoDate) return '';
    try {
        const d = new Date(isoDate);
        if (isNaN(d.getTime())) return '';
        return d.getDate();
    } catch (e) { return ''; }
}
const formatTime = (isoDate: string) => {
    if (!isoDate) return '';
    try {
        const d = new Date(isoDate);
        if (isNaN(d.getTime())) return '';
        return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    } catch (e) { return ''; }
}
</script>

<style lang="scss" scoped>

</style>